import SocialIcon from './SocialIconComponent'
export * from './SocialIconComponent'
export default SocialIcon
